{
    "RingtimeDistributionLabel": "Tempo de toque (Distribuição):",
    "RingtimeSegmentLabel": "Tempo de toque (segmento):",
    "CalltalktimeLabel": "Tempo de conversação da chamada:",
    "TotalcalltimeLabel": "Tempo total de chamada:",
    "CallheldtimeLabel": "Tempo de espera da chamada:",
    "TimeComparisonAnyOptionLabel": "[Any]",
    "TimeComparisonHigherthanOptionLabel": "Mais alto que",
    "TimeComparisonHigherequalOptionLabel": "Superior\/Igual",
    "TimeComparisonLowerthanOptionLabel": "Mais baixo que",
    "TimeComparisonLowerequalOptionLabel": "Menor\/Igual",
    "TimeComparisonBetweenOptionLabel": "Entre",
    "TimeComparisonEqualOptionLabel": "Igual",
    "TimeComparisonNotequalOptionLabel": "Não igual",
    "TimeComparisonNotbetweenOptionLabel": "Não entre",
    "TimeComparisonValue1Label": "Valor:",
    "TimeComparisonValue2Label": "E:",
    "DurationFiltering_SectionHeader": "Filtragem de duração (apenas histórico)",
    "NAME": "DurationFiltering"
}